import Chart from 'chart.js'
;(function() {
  const ctx = [].slice.call(
    document.querySelectorAll('[data-chart="score-gauge"]')
  )

  ctx.forEach(chart => {
    const ctxScore = chart.getAttribute('data-chart-score')

    new Chart(chart, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [parseInt(100 - ctxScore), parseInt(ctxScore)],
            backgroundColor: ['#CFCFD4', '#4D64FF']
          }
        ]
      },
      options: {
        cutoutPercentage: 85,
        tooltips: { enabled: false },
        hover: { mode: null },
        elements: {
          arc: {
            borderWidth: 0
          }
        }
      }
    })
  })
})()
